/** Card back — pure CSS + SVG spade (reliable on all devices/fonts) */
export default function CardBackArt({ className = '' }: { className?: string }) {
  return (
    <div className={`tp-card-back-art tp-card-back-css ${className}`.trim()} aria-hidden>
      <div className="tp-card-back-css-diamond" />
      <div className="tp-card-back-css-inner-frame" />
      <svg className="tp-card-back-css-spade" viewBox="0 0 100 100" aria-hidden focusable="false">
        <path
          fill="currentColor"
          d="M50 16 C31 36 16 42 16 57 C16 67 24 75 35 75 C41 75 46 72 50 67 C54 72 59 75 65 75 C76 75 84 67 84 57 C84 42 69 36 50 16 Z"
        />
      </svg>
    </div>
  );
}
